import { projectRequest } from 'api';
import { AxiosResponse } from 'axios';
import { stringifyUrlParams } from 'lib';
import { IAnnouncement, IGetAnnouncementArgs } from './types';

const getAnnouncements = (args: IGetAnnouncementArgs) => {
  return projectRequest(false, 'v2').get(`/announcements?${stringifyUrlParams(args)}`) as Promise<
    AxiosResponse<IAnnouncement[]>
  >;
};

export default getAnnouncements;
